/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    connectedCallback() {
      this.ticking = false;
      this._onScroll = this.checkVisible.bind(this);
      this._onResize = () => {
        this.pageHeight = window.innerHeight;
        this.updateFloatingPosition();
      };

      this.pageHeight = window.innerHeight;

      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick, { passive: true });
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this.updateFloatingPosition();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    getFloatingElements() {
      const chatLauncher = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part="activator"]');

      return [
        document.querySelector('.product-add-to-cart-sticky'),
        document.querySelector('#smile-lite-launcher-frame'),
        chatLauncher
      ].filter(Boolean);
    }

    updateFloatingPosition() {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const gap = Math.min(Math.max(viewportWidth * 0.02, 12), 24);
      const isMobileLayout = window.matchMedia('(max-width: 767px)').matches;
      let horizontalOffset = 0;
      let verticalOffset = 0;

      this.getFloatingElements().forEach((element) => {
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const isVisible = style.display !== 'none'
          && style.visibility !== 'hidden'
          && rect.width > 0
          && rect.height > 0
          && rect.left < viewportWidth
          && rect.right > 0;

        if (!isVisible) return;

        if (isMobileLayout && rect.bottom >= viewportHeight - 64) {
          verticalOffset = Math.max(verticalOffset, viewportHeight - rect.top + gap);
        }

        if (!isMobileLayout && rect.width < viewportWidth * 0.6 && rect.right >= viewportWidth - 64) {
          horizontalOffset = Math.max(horizontalOffset, viewportWidth - rect.left + gap);
        }
      });

      if (horizontalOffset > 0) {
        this.style.setProperty('--back-to-top-floating-offset', `${Math.ceil(horizontalOffset)}px`);
      } else {
        this.style.removeProperty('--back-to-top-floating-offset');
      }

      if (verticalOffset > 0) {
        this.style.setProperty('--back-to-top-sticky-bottom-offset', `${Math.ceil(verticalOffset)}px`);
      } else {
        this.style.removeProperty('--back-to-top-sticky-bottom-offset');
      }
    }

    checkVisible() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.classList.toggle('back-to-top--active', window.scrollY > this.pageHeight);
        this.updateFloatingPosition();
        this.ticking = false;
      });
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}
